import ReferAFriend from "./ReferAFriend";
import formatPrismicData from "../../hocs/formatPrismicData";
import withCountry from "../../hocs/withCountry";
import compose from "recompose/compose";

const enhance = compose(formatPrismicData, withCountry);

export default enhance(ReferAFriend);
